module.exports = __webpack_public_path__ + "img/image25.12ad4d91.png";